import { useQuery } from "@tanstack/react-query";
import adminApiClient from "api/admin";

export const STUDIO_GUIDES_QUERY_KEY = "studio-guides";

const useStudioGuides = () => {
  return useQuery({
    queryKey: [STUDIO_GUIDES_QUERY_KEY],
    queryFn: () => adminApiClient.getStudioGuides(),
  });
};

export default useStudioGuides;
